import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import posed, { PoseGroup } from 'react-pose';
import { useDispatch, useSelector } from 'react-redux';
import { CONTRAST } from '../../theme';

const BackdropAnimated = posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 },
});

const Backdrop = styled(BackdropAnimated)`
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
`;

const ModalWrapper = styled.div`
  overflow: scroll;
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: 2000;
  display: flex;
  align-items: center;
  flex-direction: column;
  &:empty {
    display: none;
  }
`;

const ModalElAnimated = posed.div({
  enter: {
    y: 0,
    opacity: 1,
    delay: 150,
    transition: {
      y: { type: 'tween', ease: 'easeIn' },
      default: { duration: 150 },
    },
  },
  exit: {
    y: 50,
    opacity: 0,
    transition: { duration: 150 },
  },
});

const Close = styled.div`
  color: ${CONTRAST};
  position: absolute;
  top: 6px;
  right: 16px;
  font-size: 36px;
  cursor: pointer;
  line-height: 1.3;
  z-index: 999;

  &:hover {
    opacity: 0.5;
  }
`;

const ModalEl = styled(ModalElAnimated)`
  position: absolute;
  width: calc(100% - 64px);
  top: 32px;
  margin-bottom: 32px;
  max-width: 1200px;
  background: white;
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    top: 0;
    border-radius: 0;
  }
`;

const mapState = ({ modal }) => ({ modal });

export const Modal = ({ modals = {} }) => {
  const { modal } = useSelector(mapState);
  const dispatch = useDispatch();

  const close = () => dispatch({ type: 'CLOSE_MODAL' });

  const isOpen = !!get(modal, 'type');

  const selectedModalObj = modals[modal.type] || {};
  const InnerComponent = selectedModalObj.component;

  return (
    <ModalWrapper open={isOpen}>
      <PoseGroup>
        {isOpen ? <Backdrop key="backdrop" onClick={close} /> : null}
        {isOpen ? (
          <ModalEl key="modal-el">
            <InnerComponent close={close} />
            <Close {...{ 'data-test': 'close-modal' }} onClick={close}>×</Close>
          </ModalEl>
        ) : null}
      </PoseGroup>
    </ModalWrapper>
  );
};
